/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-bind */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Field } from 'redux-form';
import DropdownSelect from "../../../components/core/input/DropdownSelect";
import { _ClauseGroupWrapper } from "../ClauseGroup/style";
import { _DeleteButton, _AddButton } from "../style";
import { _Disclaimer, _ActionButtonWrapper } from "./style";
var ClauseInput = function ClauseInput(_ref) {
  var clause = _ref.clause,
    conditionAttributesOptions = _ref.conditionAttributesOptions,
    conditionOperandInputOptions = _ref.conditionOperandInputOptions,
    conditionOperationsOptions = _ref.conditionOperationsOptions,
    conditionResourcesOptions = _ref.conditionResourcesOptions,
    conditionsOperationsLoading = _ref.conditionsOperationsLoading,
    disabledUpdateCondition = _ref.disabledUpdateCondition,
    displayInNotInDisclaimer = _ref.displayInNotInDisclaimer,
    fields = _ref.fields,
    handleAddAndClause = _ref.handleAddAndClause,
    index = _ref.index,
    operandArray = _ref.operandArray,
    operandInput = _ref.operandInput,
    selectedAttribute = _ref.selectedAttribute,
    selectedOperator = _ref.selectedOperator,
    selectedResource = _ref.selectedResource;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_ClauseGroupWrapper, {
    key: index,
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(Field, {
    component: DropdownSelect,
    disabled: disabledUpdateCondition,
    name: "".concat(clause, ".resource"),
    options: conditionResourcesOptions,
    placeholder: "Resource"
  }), /*#__PURE__*/React.createElement(Field, {
    component: DropdownSelect,
    disabled: !selectedResource || disabledUpdateCondition,
    name: "".concat(clause, ".attribute"),
    options: conditionAttributesOptions,
    placeholder: "Attribute"
  }), /*#__PURE__*/React.createElement(Field, {
    component: DropdownSelect,
    disabled: !selectedResource || !selectedAttribute || disabledUpdateCondition || conditionsOperationsLoading,
    loading: conditionsOperationsLoading,
    name: "".concat(clause, ".operator"),
    options: conditionOperationsOptions,
    placeholder: "Operator"
  }), /*#__PURE__*/React.createElement(Field, {
    component: operandInput,
    disabled: !selectedResource || !selectedAttribute || !selectedOperator || disabledUpdateCondition || conditionsOperationsLoading,
    matchPos: "start",
    min: 0,
    name: operandArray ? "".concat(clause, ".operandArray") : "".concat(clause, ".operand"),
    noFlex: true,
    options: conditionOperandInputOptions,
    placeholder: "Value",
    type: "select"
  }), !disabledUpdateCondition && /*#__PURE__*/React.createElement(_ActionButtonWrapper, null, /*#__PURE__*/React.createElement(_AddButton, {
    onClick: handleAddAndClause
  }, "AND"), fields.length > 1 && fields.length === index + 1 && /*#__PURE__*/React.createElement(_DeleteButton, {
    onClick: function onClick() {
      fields.remove(index);
    }
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "times"
  })))), displayInNotInDisclaimer && /*#__PURE__*/React.createElement(_Disclaimer, null, "Seperate each operand value by a comma and space (eg. 1, 2, 3, 4)"));
};
export default ClauseInput;